import React from "react";
import styled, {  ThemeProvider } from "styled-components";
import { darkTheme } from "./Themes";
import LogoComponent from "./subComponents/LogoComponent";
import SocialIcons from "./subComponents/SocialIcons";
import PowerButton from "./subComponents/PowerButton";
import ParticleComponent from "./subComponents/ParticleComponent";
// import astronaut from "../assets/Images/mahesh.png";
import BigTitle from "./subComponents/BigTitle";
import { motion } from "framer-motion";
import Typed from "react-typed"
import 'react-vertical-timeline-component/style.min.css';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { FaGraduationCap, FaUserTie } from "react-icons/fa";
import {CenterMahi} from "./subComponents/AllSvgs";


const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 300vh;
  position: relative;
  overflow-x: hidden;
`;

// const float = keyframes`
//   0%{transform: translateY(-10px)}
//   50%{transform: translateY(15px) translateX(15px)}
//   100%{transform: translateY(-10px)}
// `;

// const Spaceman = styled.div`
//   position: absolute;
//   top: 10%;
//   right: 5%;
//   width: 20vw;
//   animation: ${float} 4s ease infinite;
//   img {
//     width: 100%;
//     height: auto;
//   }
// `;

const Main = styled.div`
  // border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  // width: 50vw;
  // height: 60vh;
  z-index: 3;
  line-height: 1.5;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(0.6rem + 1vw);
  backdrop-filter: blur(4px);

  // position: relative;
  // left: calc(5rem + 5vw);
  // top: 0;

  font-family: "Ubutntu Mono", monospace;
  font-style: italic;
`;

const ImageContainer = styled.div`
  // position: relative;
  // top: 0%;
  // right: 5%;
  // width: 20vw;
  // height:60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  img {
    width: 100%;
    height: 100%;
  }
  // border: 2px solid ${(props) => props.theme.text};
`;

const RoundContainer = styled.div`
  display: flex;
  border-radius: 50%;
  border: 2px solid white;
  width: 90%;
  justify-content: center;
  text-align: center;
  box-shadow: 0 0 60px 30px #fff, /* inner white */ 0 0 100px 60px cadetblue/* outer cyan */
`;

const MainContainer = styled(motion.div)`
  position: relative;
  top: 11%;
  left: 5%;
  // border: 1px solid #fff;
  display: flex;
  @media (max-width: 700px) {
    display: block;
    top: 10%;
  }
  width: 90%;
`;

const Academics = styled.div`
  width:85%;
  // border:5px solid red;
  top:10%;
  position:relative;
  left:8%;
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.8,
      duration: 1,
    },
  },
};

const Heading = styled.div`
  width:100%;
  text-align:center;
  h1{
    margin-bottom:5%;
    color:#fff;
  }
`;

// const TimeLine = styled.div`
// width:100%;
// position:relative;
// top: 11%;
// left: 5%;
// // border: 1px solid #fff;
// margin-top:10%;
// @media (max-width: 700px) {
//   display: block;
//   top: 10%;
// }
// width: 90%;
// `;

const TimeLine = styled.div`
  width: 100%;
  position: relative;
  top: 11%;
  left: 5%;
  border: 5px solid #fff;
  // border: 1px solid #fff;
  margin-top: 10%;
  .vertical-timeline-element-date {
    color: #fff;
  }
  @media (max-width: 1160px) {
    .vertical-timeline-element-date {
      color: #000;
    }
  }
  @media (max-width: 700px) {
    display: block;
    top: 10%;
    .vertical-timeline-element-date {
      color: #000;
    }
  }
  width: 90%;
  .vertical-timeline {
    margin-bottom: 5%;
  }
`;

const Profile = styled.div`
  position:fixed;
  right:1rem;
  @media (max-width: 720px) {
    position: absolute;
}`

function AboutPage() {
  return (
    <ThemeProvider theme={darkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
        <Profile fill={darkTheme.text}>
        <CenterMahi  width={100} height={120} fill={darkTheme.text}/>
        </Profile>
        <ParticleComponent theme="dark" />
        {/* <Spaceman>
            <img src={astronaut} alt="spaceman"/>
        </Spaceman> */}
        <Academics>
          <MainContainer
            className="row"
            variants={container}
            initial="hidden"
            animate="show"
            exit={{
              opacity: 0,
              transition: { duration: 0.5 },
            }}
          >
            <Main className="col col-lg-8 col-md-8  col-sm-12 ">
            <Typed
                    strings={["I'm a Full Stack Web Developer located in India. I love to create simple yet beautiful websites with great user experience. I have developed various projects using MERN stack and like trying new things and building great projects. I'm a tech enthusiast and love to explore various new tools and write technical articles on various topics. I believe everything is an Art when you put your consciousness in it. You can connect with me via social links.",
                   ]}
                    typeSpeed={10}  
                    backSpeed={500}  
                    // loop
            />

              
            </Main>

            <ImageContainer className="col col-lg-4 col-md-4 col-sm-12 ">
              <RoundContainer>
                {/* <img src={astronaut} alt="spaceman" /> */}
              </RoundContainer>
            </ImageContainer>
          </MainContainer>

          <TimeLine>
            <Heading>
              <h1>Work Experience</h1>
            </Heading>
            <VerticalTimeline lineColor="#fff">
              <VerticalTimelineElement
                 className="vertical-timeline-element--education"
                 iconStyle={{ background: "#fff", color: "#000" }}
                 icon={<FaUserTie />}
                 date="2023 (June - Current)"
                 dateClassName="colorWhite"
              >
                <h3>Shunyeka Pvt. Ltd.</h3>
                <p>
                  <strong>Full Stack Developer Intern </strong><span style={{color:'grey',fontSize:'10pt'}}> </span> 
                </p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#000", color: "#fff" }}
                icon={<FaUserTie />}
                date="2023(Jan-June)"
                dateClassName="colorWhite"
              >
                <h3>SortWind Pvt. Ltd.</h3>
                <p>
                  <strong>Full Stack Developer Intern </strong><span style={{color:'grey',fontSize:'10pt'}}> 6 months</span> 
                </p>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#fff", color: "#000" }}
                icon={<FaUserTie />}
                date="2022 (June - Dec)"
                dateClassName="colorWhite"
              >
                <h3>CHASHW INTERNET (OPC) PVT. LTD.</h3>
                <p>
                <strong>Frontend Developer Intern </strong> <span>6 months</span>
                </p>
              </VerticalTimelineElement>

            </VerticalTimeline>
          </TimeLine>         
          <TimeLine>
            <Heading>
              <h1>Academics</h1>
            </Heading>
            <VerticalTimeline lineColor="#fff">

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#000", color: "#fff" }}
                icon={<FaGraduationCap />}
                date="2020-2024"
              >
                <h3>International Institute of Information Technology, Pune.</h3>
                <h4>B.E Computer</h4>
                <p>Second Year SGPA: <strong>9.07</strong></p>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#fff", color: "#000" }}
                icon={<FaGraduationCap />}
                date="2018-2020"
                dateClassName="colorWhite"
              >
                <h3>Loyola Junior College, Pashan</h3>
                <p>
                  HSC <strong>86.16%</strong>
                </p>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#000", color: "#fff" }}
                icon={<FaGraduationCap />}
                date="2018"
                dateClassName="colorWhite"
              >
                <h3>St. Josephs Boys High School, Khadki</h3>
                <p>
                  SSC <strong>93.00%</strong>
                </p>
              </VerticalTimelineElement>
            </VerticalTimeline>
          </TimeLine>
         
        </Academics>
        <BigTitle text="ABOUT" top="10%" left="5%" />
      </Box>
    </ThemeProvider>
  );
}

export default AboutPage;
